export const images = {
  webMiniLogoImg: require("../assets/images/web-mini-logo.webp"),
  webLogoImg: require("../assets/images/web-logo.webp"),
  webLogoFooterImg: require("../assets/images/web-logo-footer.webp"),
  bannerImg1: require("../assets/images/banner-img1.webp"),
  bannerImg1New: require("../assets/images/banner-img1-new.webp"),
  bannerImg2: require("../assets/images/banner-img2.webp"),
  bannerOneResp: require("../assets/images/banner-one-resp.webp"),
  bannerTwoResp: require("../assets/images/banner-two-resp.webp"),
  bannerImg3: require("../assets/images/router-phone-img.webp"),
  elephantImg: require("../assets/images/elephant-image.webp"),
  aboutTelecomImg: require("../assets/images/about-telecom.png"),
  broadbandElephantLeftImg: require("../assets/images/broadband-elephant-left.webp"),
  broadbandElephantRightImg: require("../assets/images/broadband-elephant-right.webp"),
  phoneCallsImg: require("../assets/images/phone-calls-cropped.webp"),
  fiberImg: require("../assets/images/fibre-broadband.webp"),
  superFastFiberCutImg: require("../assets/images/super-fast-fiber-broadband-cut.webp"),
  yeaLinkPhonImg2: require("../assets/images/yealink-phone-2.webp"),
  yeaLinkPhonImg3: require("../assets/images/yealink-phone-3.webp"),
  yeaLinkPhonImg4: require("../assets/images/yealink-phone-4.webp"),
  trustPilotImg: require("../assets/images/trust-pilot-new.webp"),
  dummyUserImg1: require("../assets/images/dummy-user-img1.webp"),
  dummyUserImg2: require("../assets/images/dummy-user-img2.png"),
  dummyUserImg3: require("../assets/images/dummy-user-img3.webp"),
  //

  yeaLinkPhoneImgNew: require("../assets/images/yealinkphonenew-img.webp"),
  yeaLinkPhoneBlackImgNew: require("../assets/images/yealink-phone-black-new-img.webp"),
  routerPhoneImg: require("./images/router-phone-img.webp"),
  routerSilverPhoneImg: require("./images/router-silver-phone.webp"),
  yealinkPhoneSilverShadowImg: require("./images/yealink-phone-silver-shadow-img.webp"),
  fibreNewImg: require("./images/fibre-new.webp"),
  phoneCallsRespImg: require("./images/phone-calls-resp.webp"),
  phoneLineRespImg: require("./images/phone-line-resp.webp"),

  loyaltyElephantImg: require("./images/loyalty-elephant.webp"),
  loyaltyElephantMobileImg: require("./images/loyalty-elephant-mobile.webp"),
  searchImg: require("./images/search.png"),
  lockImg: require("./images/lock.png"),
  giftBoxImg: require("./images/gift-box.png"),

  //

  multiMobileImg: require("./images/multi-mobile-2.png"),
  paymentMachineImg: require("./images/payment-machine-2.png"),
  paymentMobileImg: require("./images/payment-mobile.png"),
  trustPartnerImg: require("./images/partner.png"),

  // Development Service Process Images
  developmentServiceProcessImg1: require("./images/process-image-01.png"),
  developmentServiceProcessImg2: require("./images/process-image-02.png"),
  developmentServiceProcessImg3: require("./images/process-image-03.png"),
  
  // Development Service Work Images
  developmentServiceWorkImg1: require("./images/our-work-image-01.png"),
  developmentServiceWorkImg2: require("./images/our-work-image-02.png"),
  developmentServiceWorkImg3: require("./images/our-work-image-03.png"),
  developmentServiceWorkImg4: require("./images/our-work-image-04.png"),
  developmentServiceWorkImg5: require("./images/our-work-image-05.png"),

  // Development Service Banner Images
  developmentServiceBannerImg: require("./images/mobile-development-action.png"),


};

export const icons = {
  menuCircleIcon: require("../assets/icons/menu-circle.webp"),
  profileCircleIcon: require("../assets/icons/profile-circle.webp"),
  carouselLeftArrowLight: require("../assets/icons/carousel-left-arrow-light.webp"),
  carouselLeftArrowDark: require("../assets/icons/carousel-left-arrow-dark.webp"),
  carouselRightArrowLight: require("../assets/icons/carousel-right-arrow-light.webp"),
  carouselRightArrowDark: require("../assets/icons/carousel-right-arrow-dark.webp"),
  circleCheckIcon: require("../assets/icons/circle-check.webp"),
  circleChatIcon: require("../assets/icons/circle-chat.webp"),
  circleTimerIcon: require("../assets/icons/circle-timer.webp"),
  circleDownload1Icon: require("../assets/icons/circle-download-1.webp"),
  circleEuro1Icon: require("../assets/icons/pay-currency.webp"),
  circlePhone1Icon: require("../assets/icons/circle-phone.webp"),
  circleCheckBlackIcon: require("../assets/icons/circle-check-black.webp"),
  circlePlusBlackIcon: require("../assets/icons/circle-plus-black.webp"),
  circleinfinityIcon: require("../assets/icons/circle-infinity.webp"),
  circlePowerIcon: require("../assets/icons/circle-power.webp"),
  circleWorldIcon: require("../assets/icons/circle-world.webp"),
  locationIcon: require("../assets/icons/location.webp"),
  thumbsUpIcon: require("../assets/icons/thumbs-up.webp"),
  shareIcon: require("../assets/icons/share.webp"),
  flagIcon: require("../assets/icons/flag.webp"),
  cardPaymentIcon: require("../assets/icons/card-payment.png"),
  brownCardIcon: require("../assets/icons/brown-card-2.png"),
  whiteCardIcon: require("../assets/icons/white-card.png"),
  blackCardIcon: require("../assets/icons/black-card.png"),
  tickIcon: require("../assets/icons/tick.png"),
  blueDevelopmentIcon: require("../assets/icons/file-icon-blue.png"),
  whiteDevelopmentIcon: require("../assets/icons/file-icon.png"),
  saasSoftwareDevelopmentIcon: require("../assets/icons/saas.png"),
  mobileDevelopmentIcon: require("../assets/icons/mobile.png"),
  uiuxIcon: require("../assets/icons/ui-ux.png"),
  graphicDesignIcon: require("../assets/icons/graphic-design.png"),
  seoAndDigitalIcon: require("../assets/icons/seo-digital.png"),
  fullStackIcon: require("../assets/icons/full-stack.png"),
 

};

export const videos = {
  // video1: require("../assets/videos/Router.mov"),
  // video1: require("../assets/videos/Preview_Compress.mp4"),
  // video2: require("../assets/videos/dummy-google.mp4"),
  // video3: require("../assets/videos/Router_v2-compress.gif"),
};
